import { render, staticRenderFns } from "./Health.vue?vue&type=template&id=24a713c0&scoped=true&"
import script from "./Health.vue?vue&type=script&lang=ts&"
export * from "./Health.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a713c0",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a713c0')) {
      api.createRecord('24a713c0', component.options)
    } else {
      api.reload('24a713c0', component.options)
    }
    module.hot.accept("./Health.vue?vue&type=template&id=24a713c0&scoped=true&", function () {
      api.rerender('24a713c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/analytics/Health.vue"
export default component.exports